import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import Navbar from "../../Utils/Navbar/navbar-component";
import Toast from "../../Utils/Toast/toast-component";
import * as authActions from '../../Redux/Auth/AuthActions';
import landingPageImage from '../../Assets/Logo1.png'

function CommingSoon() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleRedirect = async (e) => {
        e.preventDefault();
        let path = e.target.value;
        const redirectPath = path || '/home';
        dispatch(authActions.redirectScreen(redirectPath))
        navigate(redirectPath);
    }

    return (
        <div>
            <Toast></Toast>
            <div className="min-h-full w-full">

                <Navbar />
                <header className="">
                    <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
                        {/* <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-50">בקרוב</h1> */}
                    </div>
                </header>

                <main>
                    <div className="flex justify-center content-center mx-auto max-w-7xl sm:px-6 lg:px-8 ">
                        <div className="flex bg-white dark:bg-black rounded-xl ">
                            <div className="flex py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                                <div className="flex justify-center content-center items-center flex-col mx-auto max-w-screen-sm text-center">
                                    <h1 className="mb-4 text-6xl tracking-tight font-extrabold lg:text-6xl text-blue-600 dark:text-blue-500">Coming soon </h1>
                                    <div className="flex w-1/2 justify-center align-middle ease-in delay-200">
                                        <img src={landingPageImage} alt="landing" />
                                    </div>
                                    <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">We apologize this page is not available right now , it is under maintenance.</p>
                                    <div className="flex w-1/2 justify-center align-middle content-center">
                                        <button className="button-component" onClick={handleRedirect}>Back to home page</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}

export default CommingSoon;
